import Nike from '../../assets/images/Nike.png';
import Adidas from '../../assets/images/Adidas.png';
import RedTapes from '../../assets/images/Redtape.png';
import Puma from '../../assets/images/Puma.png';
import Reebok from '../../assets/images/Reebok.png';
import Sketchers from '../../assets/images/Sketchers.png';
import HushPuppies from '../../assets/images/HushPuppies.png';
import NikeCover from '../../assets/images/nikeCover.jpg';
import AdidasCover from '../../assets/images/adidasCover.jpg';
import RedTapesCover from '../../assets/images/redtapeCover.jpeg';
import PumaCover from '../../assets/images/pumaCover.jpg';
import ReebokCover from '../../assets/images/reebokCover.jpg';
import SketcherCover from '../../assets/images/sketchersCover.jpeg';
import HushPuppiesCover from '../../assets/images/hushpuppiesCover.jpg';

const brands = [
    {
        brandName:'Nike',
        brandImageSrc:Nike,
        coverImg:NikeCover
    },
    {
        brandName:'Adidas',
        brandImageSrc:Adidas,
        coverImg:AdidasCover
    },
    {
        brandName:'Puma',
        brandImageSrc:Puma,
        coverImg:PumaCover
    },
    {
        brandName:'Reebok',
        brandImageSrc:Reebok,
        coverImg:ReebokCover
    },
    {
        brandName:'Sketchers',
        brandImageSrc:Sketchers,
        coverImg:SketcherCover
    },
    {
        brandName:'RedTape',
        brandImageSrc:RedTapes,
        coverImg:RedTapesCover
    },
    {
        brandName:'HushPuppies',
        brandImageSrc:HushPuppies,
        coverImg:HushPuppiesCover
    }
]

export default brands;